import { ResourceModal } from './ResourceModal';
export default ResourceModal;